import Vue from "vue";
import { saveAs } from "file-saver";

// Assign file-saver to Vue's prototype
Vue.prototype.$fileSaver = saveAs;
